import React from 'react';

import Styles from './HeaderCell.module.scss';

const HeaderCell = (props: React.ComponentPropsWithRef<'div'>) => {
	return <div {...props} className={Styles.container}></div>;
};

export default HeaderCell;
